"use client";

import { X } from "lucide-react";

interface TagProps {
  label: string;
  color?: string;
  onRemove?: () => void;
  className?: string;
}

export function Tag({ label, color, onRemove, className = "" }: TagProps) {
  const bgColor = color || "var(--color-accent-yellow)";

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-sm font-medium border transition-all ${onRemove ? "pr-1.5" : ""} ${className}`}
      style={{
        backgroundColor: bgColor,
        borderColor: bgColor,
        color: "var(--color-text-primary)",
      }}
    >
      {label}
      {onRemove && (
        <button
          onClick={onRemove}
          className="flex-shrink-0 hover:bg-[var(--color-surface-hover)] rounded-full p-0.5 transition-colors"
          aria-label={`${label} 제거`}
        >
          <X className="w-3 h-3" />
        </button>
      )}
    </span>
  );
}

export type { TagProps };
